import * as React from 'react';
import PropTypes from 'prop-types';
import { AppBar } from '@material-ui/core';
import { Toolbar } from '@material-ui/core';
import {CssBaseline} from '@material-ui/core';
import {useScrollTrigger} from '@material-ui/core';
import LandingButtons from './LandingButton';
import MenuComponent from './MenuComponent';
import Logo from './../image/glimpist_logo.svg'
import SearchIcon from '@material-ui/icons/Search';
import { Link } from 'react-router-dom';

function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};


export default function ElevateAppBar(props) {
  return (
    <React.Fragment>
      
        <AppBar style={{
          backgroundColor: 'var(--secondary)',
          boxShadow: '0px 0px 0px grey'
          }}>
          <Toolbar>
          <div className= 'navbar-container'>
        
        <div className = 'navbar-left'>
        
        <Link to= "/"> <img src = {Logo}/> </Link>
        
            <Link to= "/"><h6 className='company-name'>Glimbay</h6></Link>
       
       
        </div>

        <div className = 'navbar-right'>

        <LandingButtons/>

        

        <div className = 'menu-button-mainpage'>
        <MenuComponent />
        </div>

        </div>


       </div>  
          </Toolbar>
        </AppBar>
     
      <Toolbar />
     
    </React.Fragment>
  );
}